addEventListener("message", (event) => {
    if (event.data.indexOf("start:") === 0) {
        const interval = parseInt(event.data.substring(6));
        if (!(interval > 0)) {
            postMessage("stop");
            return;
        }
        setInterval(() => postMessage("tick"), interval);
    }
});
